export type ReductionOutcome = 'HOME' | 'DRAW' | 'AWAY';

export const SCORE_REDUCTIONS: ReductionOutcome[] = ['HOME', 'DRAW', 'AWAY'] as const;
